/* eslint-disable camelcase */
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosWIS";

export interface Priority extends Record<string, unknown> {
  id: string;
  pk_prt_id: number;
  prt_name: string;
  prt_color: string;
  prt_desc: string;
  prt_is_default: boolean;
  prt_status: string;
  created_by: string;
  create_timestamp: string;
  update_by: string;
  update_timestamp: string;
  inc_priority_order: number;
  version: number;
}

export const usePriorities = (
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<Priority>> => {
  return useSwr<ApiArrayResponse<Priority>>(`/api/Priority`, config);
};
